import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'header-component',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @Input() enableBack: boolean = true;
  @Input() enableLogo: boolean = false;
  @Input() isSettingsPage: boolean = false;
  @Input() isHomePage: boolean | null = false;
  @Input() enableTitle: boolean = true;
  @Input() goToSettings: boolean = false;
  @Input() goToDashboard: boolean = false;
  @Input() enableSaveBtn: boolean = false;
  @Input() enableClearBtn: boolean = false;
  @Input() linkText: string = '';
  @Input() defaultLink: string = '';
  @Input() saveTitle: string = 'Save';
  @Input() titleText: string = '';

  @Input() enableMenu: boolean = false;
  @Input() menuTitle: string = 'Notifications';
  @Input() menuOptions?: { title: string, func: any }[];

  @Output() saveBtn: EventEmitter<void> = new EventEmitter();
  @Output() clearBtn: EventEmitter<void> = new EventEmitter();

  constructor(
    private menuCtrl: MenuController,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.menuCtrl.enable(true);
  }

  ngAfterViewInit(): void {}

  public openSettings(): void {
    this.router.navigate(['/dashboard/settings']);
  }
  public openDashboard(): void {
    this.authService.getUserAttributes(
      (err: any) => {
        console.error('Error during re-login:', err);
      },
      (res: any) => {
        this.router.navigate(['/dashboard']);
      }
    );
  }

  openMenu() {
    this.menuCtrl.open('menuId');
    setTimeout(()=>{
      this.menuCtrl.isOpen().then(res=>{
        if(res)this.menuCtrl.close('menuId');
      });
    },9*60*1000);
  }

  closeMenu() {
    this.menuCtrl.close('menuId');
  }
}
